import React, { useEffect, useState } from "react";
import { Table, Card } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./DashboardMerchantsEmployees.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';

const employee = [
  {
    workingPeriod: "2014 - 2016",
    image: "assests/images/pp3.png",
    merchantName: "John Doe",
    employeeId: "ID-1564",
    receiptNo: "INV12345",
    commission: 500,
    commissionPercent: "03%"
  },
  {
    workingPeriod: "2014 - 2016",
    image: "assests/images/pp3.png",
    merchantName: "Sarah Smith",
    employeeId: "ID-15656",
    receiptNo: "INV12345",
    commission: 570,
    commissionPercent: "09%"
  },
  {
    workingPeriod: "2014 - 2016",
    image: "assests/images/pp3.png",
    merchantName: "James Brown",
    employeeId: "ID-1548",
    receiptNo: "INV12345",
    commission: 750,
    commissionPercent: "09%"
  },
  {
    workingPeriod: "2014 - 2016",
    image: "assests/images/pp3.png",
    merchantName: "Emma Wilson",
    employeeId: "ID-1565",
    receiptNo: "INV12345",
    commission: 250,
    commissionPercent: "09%"
  },
  {
    workingPeriod: "2014 - 2016",
    image: "assests/images/pp3.png",
    merchantName: "Michael John",
    employeeId: "ID-21645",
    receiptNo: "INV12345",
    commission: 600,
    commissionPercent: "09%"
  },
  {
    workingPeriod: "2014 - 2016",
    image: "assests/images/pp3.png",
    merchantName: "Sarah Smith",
    employeeId: "ID-1564",
    receiptNo: "INV12345",
    commission: 250,
    commissionPercent: "03%"
  },
  {
    workingPeriod: "2014 - 2016",
    image: "assests/images/pp3.png",
    merchantName: "John Doe",
    employeeId: "ID-1564",
    receiptNo: "INV12345",
    commission: 500,
    commissionPercent: "09%"
  },
  {
    workingPeriod: "2014 - 2016",
    image: "assests/images/pp3.png",
    merchantName: "James Brown",
    employeeId: "ID-1564",
    receiptNo: "INV12345",
    commission: 750,
    commissionPercent: "09%"
  },
  {
    workingPeriod: "2014 - 2016",
    image: "assests/images/pp3.png",
    merchantName: "Emma Wilson",
    employeeId: "ID-1564",
    receiptNo: "INV12345",
    commission: 600,
    commissionPercent: "09%"
  },
  {
    workingPeriod: "2014 - 2016",
    image: "assests/images/pp3.png",
    merchantName: "Sarah Smith",
    employeeId: "ID-1564",
    receiptNo: "INV12345",
    commission: 250,
    commissionPercent: "09%"
  }
];

const DashboardMerchantsEmployees = () => {
  const [loading, setLoading] = useState(true);
  const { id, store_id } = useParams();
  const [isMobile, setIsMobile] = useState(false);
  const [emAccordionOpen, setemAccordionOpen] = useState(false);

  const [inputs, setInputs] = useState({ id: '', image: '', name: '', emp_id: '', join_date: '', dob: '', emp_mobile: '', email: '' });

  const [setirowsPerPage, setsetiRowsPerPage] = useState(10);
  const [seticurrentPage, setsetiCurrentPage] = useState(1);

  const setitotalPages = Math.ceil(employee.length / setirowsPerPage);

  const currentsetiData = employee.slice(
    (seticurrentPage - 1) * setirowsPerPage,
    seticurrentPage * setirowsPerPage
  );

  const handlesetiPageChange = (page) => {
    if (page > 0 && page <= setitotalPages) {
      setsetiCurrentPage(page);
    }
  };

  const handlesetiRowsChange = (e) => {
    setsetiRowsPerPage(parseInt(e.target.value));
    setsetiCurrentPage(1);
  };

  const [activeTab, setActiveTab] = useState('Employees');

  const renderTabContent = () => {
    switch (activeTab) {
      case "Salesperson Info":
        return;

      case "Subscription Status":
        return;

      case "Employees":
        return <div className="col-12 holisti">
          <Card className="h-100">
            <div className="d-flex flex-column-reverse flex-md-row justify-content-between align-items-md-center">
              <Card.Title className="d-none d-md-block">Employment History:</Card.Title>
              <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0">
                <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                  <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                    <div className="input-group">
                      <div className="input-group-text border-end-0">
                        <img
                          src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                          alt="Search Icon"
                          className="img-fluid"
                        />
                      </div>
                      <input
                        type="text"
                        className="form-control border-start-0 ps-0"
                        placeholder="Search"
                      />
                    </div>
                  </div>
                  <button type="button" className="sloti">
                    <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2" /> Sort
                  </button>
                </div>
              </div>
            </div>

            <div className="table-ro mt-2 d-none d-md-block">
              <Table
                responsive
                className="table-no-last-border mb-0"
              >
                <thead className="table">
                  <tr className="custom-header">
                    <th className="lft">Working Period</th>
                    <th>Merchant ID #</th>
                    <th>Employee ID</th>
                    <th>Receipt #</th>
                    <th>Commission ($)</th>
                    <th>Commission %</th>
                  </tr>
                </thead>
                <tbody>
                  {currentsetiData.map((item, index) => (
                    <tr key={index}>
                      <td className="lef">{item.workingPeriod}</td>
                      <td><img src={process.env.REACT_APP_BASE_URL + item.image} alt={item.name} className="ppt1 me-2" />
                        <Link to={process.env.REACT_APP_BASE_URL + "merchant-subscription"}>{item.merchantName}</Link></td>
                      <td>{item.employeeId}</td>
                      <td>{item.receiptNo}</td>
                      <td>{item.commission}</td>
                      <td className="ref">{item.commissionPercent}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="col-12 d-flex align-items-center justify-content-between firsty d-md-none"
              onClick={() => isMobile && setemAccordionOpen(!emAccordionOpen)}
              style={{ cursor: isMobile ? "pointer" : "default" }}
            >
              <h5>Employees</h5>
              {isMobile && (
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    (emAccordionOpen ? "assests/images/aco-up.png" : "assests/images/aco-down.png")
                  }
                  alt="Toggle Arrow"
                />
              )}
            </div>
            {(!isMobile || emAccordionOpen) && (
              <>
                <div className="d-md-none mb-3 ev-mobilex">
                  {currentsetiData.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 mb-3 main"
                    >
                      {/* Top row: Join date and Active tag */}
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="date">{item.employeeId}</div>
                        <div className="date">{item.workingPeriod}</div>
                      </div>

                      {/* Image + Name + Contact */}
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                          <img
                            src={item.image}
                            alt={item.name}
                            className="ppt1"
                          />
                          <div className="ms-2 fgtrx">
                            <Link to={process.env.REACT_APP_BASE_URL + "merchant-subscription"}>{item.merchantName}</Link>
                          </div>
                        </div>
                        <div className="kayde">${item.commission.toFixed(2)}</div>
                      </div>

                      <div className="row ojuxi">
                        <div className="col-6">
                          <h2>Receipt #</h2>
                          <h3>{item.receiptNo}</h3>
                        </div>
                        <div className="col-6">
                          <h2>Commission %</h2>
                          <h3>{item.commissionPercent}</h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                  <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex chelu">
                    <label>Show rows:</label>
                    <select
                      value={setirowsPerPage}
                      onChange={handlesetiRowsChange}
                      className="form-select w-auto"
                    >
                      <option value={10}>10 items</option>
                      <option value={15}>15 items</option>
                      <option value={20}>20 items</option>
                      <option value={25}>25 items</option>
                    </select>
                  </div>

                  <nav>
                    <ul className="pagination pagination-sm mb-0">
                      {/* Previous */}
                      <li className={`page-item ${seticurrentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => handlesetiPageChange(seticurrentPage - 1)}
                        >
                          &lt;
                        </button>
                      </li>

                      {/* First */}
                      <li className={`page-item ${seticurrentPage === 1 ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlesetiPageChange(1)}>
                          1
                        </button>
                      </li>

                      {/* Left Dots */}
                      {seticurrentPage > 3 && setitotalPages > 5 && (
                        <li className="page-item disabled">
                          <span className="page-link">...</span>
                        </li>
                      )}

                      {/* Middle Pages */}
                      {Array.from({ length: setitotalPages }, (_, i) => i + 1)
                        .filter((page) => {
                          return (
                            page !== 1 &&
                            page !== setitotalPages &&
                            Math.abs(seticurrentPage - page) <= 1
                          );
                        })
                        .map((page) => (
                          <li
                            key={page}
                            className={`page-item ${seticurrentPage === page ? "active" : ""}`}
                          >
                            <button className="page-link" onClick={() => handlesetiPageChange(page)}>
                              {page}
                            </button>
                          </li>
                        ))}

                      {/* Right Dots */}
                      {seticurrentPage < setitotalPages - 2 && setitotalPages > 5 && (
                        <li className="page-item disabled">
                          <span className="page-link">...</span>
                        </li>
                      )}

                      {/* Last */}
                      {setitotalPages > 1 && (
                        <li
                          className={`page-item ${seticurrentPage === setitotalPages ? "active" : ""}`}
                        >
                          <button className="page-link" onClick={() => handlesetiPageChange(setitotalPages)}>
                            {setitotalPages}
                          </button>
                        </li>
                      )}

                      {/* Next */}
                      <li className={`page-item ${seticurrentPage === setitotalPages ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => handlesetiPageChange(seticurrentPage + 1)}
                        >
                          &gt;
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </>
            )}
          </Card>
        </div>;

      case "Products":
        return;

      case "Coupons":
        return;

      case "Customers":
        return;

      case "Income & Forecast":
        return;

      default:
        return null;
    }
  };

  useEffect(() => {
    document.title = `Dashboard-Merchants-profile | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('store_id', store_id);
    formData.append('id', id);
    API.post('backoffice_merchant_employee_detail', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInputs({
            id: response.data.data.id,
            image: response.data.data.image,
            name: response.data.data.name,
            emp_id: response.data.data.emp_id,
            join_date: response.data.data.join_date,
            dob: response.data.data.dob,
            emp_mobile: response.data.data.emp_mobile,
            email: response.data.data.email
          });
        }
      }).catch(error => {
        setLoading(false);

      });

    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [id, store_id]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12">
                    <h1>Employment</h1>
                    <div className="vnfro shadow-md-none">
                      <div className="row d-flex align-items-center mb-4 kjuk">
                        {/* Profile Image */}
                        <div className="col-4 col-md-2 leki">
                          <img
                            src={process.env.REACT_APP_BASE_URL + 'assests/images/elii.png'}
                            alt="Profile"
                            className="img-fluid"
                          />
                        </div>

                        {/* Store Info */}
                        <div className="col-8 col-md-6 infea fgfr">
                          <p>Employee Name</p>
                          <h5>{inputs.name}</h5>
                          <div className="ids">ID# {inputs.emp_id}</div>
                          <div className="date">Join Date: {inputs.join_date}</div>
                        </div>
                      </div>

                      {/* Desktop */}
                      <div className="row mt-3 d-none d-md-flex">
                        <div className="col-md-4">
                          <div className="mb-3">
                            <div className="col-5 text-start tatly mb-1">DOB</div>
                            <div className="col-6 latly">{inputs.dob}</div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <div className="col-5 text-start tatly mb-1">Phone Number</div>
                            <div className="col-6 latly">{inputs.emp_mobile}</div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <div className="col-5 text-start tatly mb-1">Email</div>
                            <div className="col-6 latly">{inputs.email}</div>
                          </div>
                        </div>
                      </div>

                      {/* Mobile */}
                      <div className="row mt-3 d-md-none">
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Phone Number</div>
                          <div className="latly">{inputs.emp_mobile}</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Email</div>
                          <div className="latly">{inputs.email}</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">DOB</div>
                          <div className="latly">{inputs.dob}</div>
                        </div>
                      </div>

                      {/* Footer Tabs (Nav Tabs Style) */}
                      <ul className="nav nav-tabs mt-4 d-none d-md-flex gap-2">
                        {[
                          { key: "Salesperson Info", label: "Salesperson Info" },
                          { key: "Subscription Status", label: "Subscription Status" },
                          { key: "Employees", label: "Employees" },
                          { key: "Products", label: "Products" },
                          { key: "Coupons", label: "Coupons" },
                          { key: "Customers", label: "Customers" },
                          { key: "Income & Forecast", label: "Income & Forecast" },
                        ].map((tab) => (
                          <li className="nav-item" key={tab.key}>
                            <button
                              className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                              onClick={() => setActiveTab(tab.key)}
                            >
                              {tab.label}
                            </button>
                          </li>
                        ))}
                      </ul>

                      {/* Footer Monile (Nav Tabs Style) */}
                      <div className="d-md-none overflow-auto mt-4">
                        <ul className="nav nav-tabs flex-nowrap text-nowrap">
                          {[
                            { key: "Salesperson Info", label: "Salesperson Info" },
                            { key: "Subscription Status", label: "Subscription Status" },
                            { key: "Employees", label: "Employees" },
                            { key: "Products", label: "Products" },
                            { key: "Coupons", label: "Coupons" },
                            { key: "Customers", label: "Customers" },
                            { key: "Income & Forecast", label: "Income & Forecast" },
                          ].map((tab) => (
                            <li className="nav-item" key={tab.key}>
                              <button
                                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                                onClick={() => setActiveTab(tab.key)}
                              >
                                {tab.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 gytf">{renderTabContent()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  );
};

export default DashboardMerchantsEmployees;